/**
 * Lead-time label helpers, shared by the quote preview (longest-lead-time
 * selection) and the part-order place-order dialog (expected-delivery
 * pre-fill). Mirrors the backend `lead_time_upper_days`
 * (sm4rt-api core/services/part_order_service.py) — keep them in sync.
 */

/**
 * Parse a lead-time label (e.g. `"2-3 weeks"`, `"1 week"`, `"5 days"`) into the
 * upper-bound number of calendar days. Returns null when the input doesn't
 * match the accepted `N`/`N-M` `days|weeks` format. Weeks are ×7.
 */
export function parseLeadTimeUpperDays(label: string): number | null {
  const m = /(\d+)(?:\s*-\s*(\d+))?\s*(days?|weeks?)/i.exec(label);
  if (!m) return null;
  const upper = m[2] ? Number(m[2]) : Number(m[1]);
  if (!Number.isFinite(upper) || upper <= 0) return null;
  const unit = m[3].toLowerCase();
  return unit.startsWith('week') ? upper * 7 : upper;
}
